import { render, staticRenderFns } from "./FreeCourse.vue?vue&type=template&id=0a4535bc"
import script from "./FreeCourse.vue?vue&type=script&lang=js"
export * from "./FreeCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports